import React, { PureComponent } from "react";
import NumberFormat from "react-number-format";
import classNames from "classnames";

import { FocusHelper } from "../utils/focus-helper";

export default class TextBox extends PureComponent {
  AllowNegatives = false;

  getNummericValue(str) {
    const { AllowNull } = this.props;

    let numb = undefined;
    if (this.props.ScriptConfig !== "decimal") {
      if (this.props.ScriptConfig === "money" && this.AllowNegatives) {
        numb = str.match(/-?\d/g);
      } else {
        numb = str.match(/\d/g);
      }
      if (numb) {
        numb = numb.join("");
      } else if (AllowNull) {
        return numb;
      }
    } else {
      numb = str;
    }

    return numb || "";
  }

  onFormatedValueChanged(event) {
    let value = this.getNummericValue(event.target.value);
    this.props.onChange(value);
  }

  handleChange = (event) => {
    if (this.props.Value !== event.target.value) {
      this.props.onChange(event.target.value);
    }
  };

  render() {
    let input = this.createInput();
    return (
      <div
        className="form-group"
        style={{ width: "auto" }}
        data-source-id={this.props.SourceId}
      >
        {input}
      </div>
    );
  }

  createInput() {
    const formatMoney = (val) => {
      let isNegative = ~val.indexOf("-");
      if (isNegative) {
        val = val.replace(/-/gi, "");
      }

      if (val.length > 9) {
        val = val.substr(0, 9);
      }

      for (let i = 0; i < Math.floor((val.length - (i + 1)) / 3); i++) {
        let comPos = (i + 1) * 3 + i;
        val =
          val.substr(0, val.length - comPos) +
          "," +
          val.substr(val.length - comPos, comPos);
      }

      return "$ " + (isNegative && this.AllowNegatives ? "-" : "") + val;
    };

    const { ValidationMessages, Value, PlaceholderText, Scale } = this.props;
    const inputClass = classNames({
      "money-box": true,
      "is-invalid": ValidationMessages.length > 0,
    });
    let input = <div />;
    let removeFormatting = undefined;

    let decimalSeparator = undefined;
    let decimalScale = Scale;
    let format = undefined;
    let placeHolder = PlaceholderText;
    let emptyFormatting = undefined;
    emptyFormatting = true;
    format = formatMoney;

    removeFormatting = (str) => {
      if (str) {
        var ind = str.indexOf(".");
        if (ind > 0) {
          str = str.substring(0, ind);
        }

        if (this.AllowNegatives) {
          str = (str.match(/-?\d?/g) || []).join("");
        } else {
          str = (str.match(/\d/g) || []).join("");
        }
      }
      return str;
    };

    input = (
      <NumberFormat
        autoComplete={"off"}
        onFocus={(e) => {
          FocusHelper.onFocusAction(e.target);
          e.target.select();
        }}
        type="text"
        format={format}
        allowNegative={this.AllowNegatives}
        decimalSeparator={decimalSeparator}
        decimalScale={decimalScale}
        placeholder={placeHolder}
        className={inputClass}
        onBlur={(event) => this.onFormatedValueChanged(event)}
        value={Value || ""}
        renderText={(value) => <div> {"$ " + value}</div>}
        allowEmptyFormatting={emptyFormatting}
        removeFormatting={removeFormatting}
      />
    );

    return input;
  }
}
